import type { FC } from "react";

import classNames from "classnames";

import { LongArrowBackwardIcon } from "@jti/brand-icons/long-arrow-backward";
import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { ReplayIcon } from "@jti/brand-icons/replay";
import { Button } from "@jti/core-components/components/Button";

import styles from "./FlavorFinderButtons.module.scss";

type FlavorFinderQuizButtonProps = {
  onClick: () => void;
  label: string;
  disabled?: boolean;
  hidden?: boolean;
};

type FlavorFinderAnswerButtonProps = {
  title: string;
  subtitle?: string;
  isActive?: boolean;
};

export const FlavorFinderNextButton: FC<FlavorFinderQuizButtonProps> = ({ onClick, label, disabled, hidden }) => {
  return (
    <Button
      data-testid="flavor-finder-next-button"
      disabled={disabled}
      variant="text-muted"
      onClick={onClick}
      className={classNames("light-theme", { [styles.hidden]: hidden })}
      iconAfter={LongArrowForwardIcon}
    >
      {label}
    </Button>
  );
};

export const FlavorFinderBackButton: FC<FlavorFinderQuizButtonProps> = ({ onClick, label }) => {
  return (
    <button
      onClick={onClick}
      className={classNames(styles.button, styles.buttonPrevious)}
      data-testid="flavor-finder-back-button"
    >
      <LongArrowBackwardIcon className={styles.buttonIcon} />
      {label}
    </button>
  );
};

export const FlavorFinderResetButton: FC<FlavorFinderQuizButtonProps> = ({ onClick, label }) => {
  return (
    <button
      onClick={onClick}
      className={classNames(styles.button, styles.buttonReset)}
      data-testid="flavor-finder-reset-button"
    >
      <ReplayIcon className={styles.buttonIcon} />
      {label}
    </button>
  );
};

export const FlavorFinderSkipButton: FC<FlavorFinderQuizButtonProps> = ({ onClick, label }) => {
  return (
    <Button
      data-testid="flavor-finder-skip-button"
      size="sm"
      variant="text-muted"
      onClick={onClick}
      className="light-theme"
      iconAfter={LongArrowForwardIcon}
    >
      {label}
    </Button>
  );
};

export const FlavorFinderResultsButton: FC<FlavorFinderQuizButtonProps> = ({ onClick, label }) => {
  return (
    <Button
      onClick={onClick}
      className={classNames("light-theme", styles.button, styles.buttonResult)}
      data-testid="flavor-finder-skip-button"
      variant="primary"
    >
      {label}
    </Button>
  );
};

export const FlavorFinderStartQuizButton: FC<FlavorFinderQuizButtonProps> = ({ onClick, label }) => {
  return <FlavorFinderNextButton onClick={onClick} label={label} />;
};

export const FlavorFinderAnswerButton: FC<FlavorFinderAnswerButtonProps> = ({ title, subtitle, isActive }) => {
  return (
    <button
      data-testid="flavor-finder-answer-button"
      className={classNames(styles.buttonAnswer, { [styles.buttonAnswerActive]: isActive })}
      aria-pressed={isActive}
      aria-label={title}
    >
      <div className={styles.answerTitle}>{title}</div>
      {subtitle && <div className={styles.answerSubtitle}>{subtitle}</div>}
    </button>
  );
};
